/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Homepage.css';
import Model from './../../components/Model'
import Link from './../../components/Link'
import cx from 'classnames';
// @ts-ignore
import errPic from './error.png'
import history from '../../history';
import { updateUser, getUser, getBrandName } from '../../controller';


class Homepage extends React.Component {
  static propTypes = {

  };
  constructor(props) {
    super(props);

    this.state = {
      value:'',
      isShowModel:false,
      isEdit: true,
      isChecked: false,
      name: '',
      phone: '',
      email: '',
      company: '',
      job: '',
      error: false,
      exDays:'',
      gender:'',
      typeHasEdit:false,

      seaCompleteItem:[],
      isFixed:false,
      listIndex:0,
      selectIndex:0,
      mouseLeave:true,
      brandList:[]
    }
    this.changeCheck=this.changeCheck.bind(this)
    this.handlerChange=this.handlerChange.bind(this)
    this.changeEdit=this.changeEdit.bind(this)
    this.handleSubmit=this.handleSubmit.bind(this)
    this.closeModel=this.closeModel.bind(this)
    this.saveToState=this.saveToState.bind(this)

    this.seaComplete=this.seaComplete.bind(this)
    this.mouseSlect=this.mouseSlect.bind(this)
    this.mouseOnClick=this.mouseOnClick.bind(this)
    this.mouseLeave=this.mouseLeave.bind(this)
    this.mouseEnter=this.mouseEnter.bind(this)
    this.isFocusFalse=this.isFocusFalse.bind(this)
  }
  
  handlerChange(type, event) {
    let newState = {};
    newState[type] = event.target.value;

  　this.setState(newState);
  }
  saveToState=(e)=>{
    const{name,value}=e.target

    this.setState({[name]:value})
    if(name=='company'){
      this.seaComplete(value)
    }
  }

  changeCheck() {
    this.setState({
      isChecked: !this.state.isChecked
    })
  }

  changeEdit() {
    let isEdit = !this.state.isEdit
    this.setState({
      isEdit
    })
  };

  handleSubmit=(e)=>{
    e.preventDefault()
    const {isEdit,gender,company,email,name,job,isChecked}=this.state
    let genderUser
    if(isChecked){
      genderUser=0
    }else{
      genderUser=1
    }

    if(!isEdit){
      updateUser({
        position:job,
        gender:genderUser,
        company:company,
        name:name,
        mail:email
      })
        .then(res => {
          if(res.err_code==0){
            alert('修改成功')
            // console.log(value)
            window.localStorage.setItem('isCom',`${res.isCom}`)
            window.localStorage.setItem('company',`${res.company}`)
          }else if(res.err_code!=404){

            this.setState({
              value:res,
              company:res.company,
              exDays:res.expire_days,
              email:res.mail,
              phone:res.phone,
              job:res.position,
              name:localStorage.getItem('user')
            })
            // console.log(value)
          }
        })
    }
  }
  closeModel=()=>{
      this.setState({isShowModel:false})
  }
  componentDidMount() {

    if(localStorage.getItem('isLogin')=='true'){

      getUser()
        .then(res => {
          if(res.err_code=='need_login'){
            alert('需要重新登录')
            history.push('/')
          }else if(res.err_code!=404){
            let genderUser
            if(res.gender==0){
              genderUser=true
            }else if(res.gender==1){
              genderUser=false
            }
              this.setState({
                value:res,
                company:res.company,
                exDays:res.expire_days,
                email:res.mail,
                phone:res.phone,
                job:res.position==='null'?'':res.position,
                gender:res.gender,
                isChecked:genderUser,
                name:localStorage.getItem('user'),
                brandList:res.init_brands||[],
                typeHasEdit:res.user_type?(res.user_type===0?true:false):true
              })
          }
        })
    }else {
      this.setState({
        error: true
      })
    }
  }


  seaComplete=(value)=>{
    if(value!=''){
      getBrandName({q: value})
        .then(res => {
          this.setState({
            seaCompleteItem: res.items
          })
        })
    }
  }
  mouseEnter=()=>{
    this.setState({mouseLeave:false})
  }
  mouseLeave=()=>{
    this.setState({mouseLeave:true})
  }

  mouseSlect=(index)=>{
    this.setState({selectIndex:index})
  }

  mouseOnClick=()=>{
    const {seaCompleteItem,selectIndex}=this.state
    // this.props.getBrand(seaCompleteItem[selectIndex].name)
    this.setState({
      company:seaCompleteItem[selectIndex].name,
      seaCompleteItem:[]
    })
  
  }
  
  isFocusFalse=()=> {
    // console.log('失去焦点')
    if(this.state.mouseLeave){
      this.setState({
        seaCompleteItem: []
      })
    }
  
  }

  render() {

    const {name,email,phone,job,exDays,company,isEdit,isChecked,selectIndex,seaCompleteItem,error,brandList,typeHasEdit}=this.state

    if(error){
      return (
        <div className={s.errorBox}>
          <div className={s.box}>
              <img src={errPic}/>
          </div>
        </div>
      )
    }else{
      return (
        <div className={s.content}>
          <div className={s.clearfix}>

            <div className={s.pageOption}>
              <div className={s.pageTit}>个人中心</div>
              <span className={s.pageInfo}>基本信息</span>
            </div>
            <div className={s.userTip}>
              <span className={s.userTipTxt}>{exDays>0?`您距离产品试用期结束还有${exDays}天，赶快成为正式用户吧`:`您享有的免费试用期已经到期，成为正式付费用户，享有更多权益和服务！`}</span>
              <a href="#" className={s.userBtn} onClick={()=>this.setState({isShowModel:true})}>成为正式用户</a>
            </div>
            <div className={s.pageCon}>
              <div className={s.pageTit}>
                基本信息
              </div>
              <span
                className={isEdit?s.editNot:s.edit}
                onClick={this.changeEdit}>编辑</span>
              <form method='post'onSubmit={this.handleSubmit}>

                <ul className={s.ulInput}>
                  <li>
                    <label htmlFor="">姓名</label><input name='name' type="text" id="" value={this.state.name} disabled={this.state.isEdit} onChange={this.saveToState} />
                    <span >{this.state.error}</span>
                  </li>
                  <li>
                    <label htmlFor="">性别</label>
                    <input type="radio" name="" id="" value="" className={s.sex} checked={this.state.isChecked} 
                    onChange={()=>{
                      if(!isEdit){
                        this.setState({isChecked:!isChecked})
                      }}
                    } />
                    <label htmlFor="">男</label>
                    <input type="radio" name="" id="" value="" className={s.sex} checked={!this.state.isChecked} 
                    onChange={()=>{
                      if(!isEdit){
                        this.setState({isChecked:!isChecked})
                      }}
                    }/>
                    <label htmlFor="">女</label>
                  </li>
                  <li>
                    <label htmlFor="" className={s.phone}>手机号</label><input type="text" name='phone' id="" value={this.state.phone} disabled={true} onChange={this.saveToState} /></li>
                  <li>
                    <label htmlFor="">邮箱</label><input type="text" name='email' id="" value={this.state.email} disabled={this.state.isEdit} onChange={this.saveToState} /></li>
                  <li>
                    <label htmlFor="">品牌</label><input type="text" name='company' id="" value={this.state.company} disabled={typeHasEdit?true:isEdit}  onChange={this.saveToState} onBlur={this.isFocusFalse} />
                    <div className={s.cardInput}>
                        <ul className={seaCompleteItem.length == 0 ? s.hide : s.seaItems} 
                        onMouseLeave={this.mouseLeave}
                        onMouseEnter={this.mouseEnter}
                        >
                          {seaCompleteItem
                            .map((item, index) => (
                              <li key={index} className={selectIndex % seaCompleteItem.length == index ? cx(s.seaItem, s.seaAc) : s.seaItem}
                                  onMouseEnter={()=>this.mouseSlect(index)}
                                  onClick={this.mouseOnClick}
                              >
                                <b><img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`} /></b>
                                {item.name}
                              </li>

                            ))}
                        </ul>
                      </div>  
                  </li>
                  <li>
                    <label htmlFor="">职位</label><input type="text" name='job' id="" value={this.state.job} disabled={this.state.isEdit} onChange={this.saveToState} /></li>
                  <li>
                    <label htmlFor="">密码</label>
                    <Link to='/forgetpwd' className={s.changePws}>修改密码</Link>
                  </li>
                  <li className={s.brands}>
                    <label htmlFor="">查看品牌权限</label>
                    
                    <ul>
                      {brandList.map((i)=>(
                        <li key={i}><Link to={`/dashboard?brandName=${i}`} >{i}</Link></li>
                      ))}
                    </ul>
                  </li>
                  <li className={!isEdit?s.show:s.hide}><input className={s.simBtn} type="submit" id="changeInfo" value="提交" /></li>

                </ul>
              </form>

            </div>
          </div>

          {/* <div className={s.model}>
            <div className={s.tipBox}>
              <div className={s.tipTxt}>感谢您的支持！请保持手机畅通，稍后数据顾问将 主动联系您。</div>
              <div className={s.tipOK}>确认</div>
            </div>

          </div> */}
          <Model isShow={this.state.isShowModel} close={()=>this.setState({isShowModel:false})}/>
        </div>
      );
    }
  
  }
}

export default withStyles(s)(Homepage);



// WEBPACK FOOTER //
// src/routes/homepage/Homepage.js